import React from 'react';
// import React from 'react';
// import PropTypes from 'prop-types';
import { BiListUl } from 'react-icons/bi';
import SideList from 'partial/wrappers/SideList';
import CountCard from 'partial/dashboard/CountCard';
import TransactionTable from 'core-modules/dashboard/components/TransactionTable';
import { useChannelSelected, useChannelCountCard } from '../hooks';
import ChannelHeader from '../components/ChannelHeader';
import ChannelList from '../components/ChannelList';

function ChannelTransaction() {
  const renderList = React.useCallback(
    (selected, onSelect) => (
      <ChannelList onSelect={onSelect} selected={selected} add={false} />
    ),
    []
  );
  const [isLoading, data] = useChannelSelected();
  return (
    <SideList id="channel-txn" renderList={renderList}>
      <div className="bg-gray-50 min-h-full flex-grow flex flex-col">
        <ChannelHeader data={data} isLoading={isLoading} readOnly />
        <dl className="mt-5 grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow-primary divide-y divide-gray-200 md:grid-cols-2 md:divide-y-0 md:divide-x mx-8">
          <CountCard
            name="total_transactions"
            label="Total Transactions"
            icon={BiListUl}
            hook={useChannelCountCard}
          />
          <CountCard
            name="total_collections"
            label="Total Collections"
            icon={BiListUl}
            hook={useChannelCountCard}
          />
        </dl>
        {data.id ? (
          <div className="mt-6 px-4 pb-8 sm:px-6 lg:px-8 flex-1 flex flex-col">
            <TransactionTable filterChannel={false} />
          </div>
        ) : null}
      </div>
    </SideList>
  );
}

ChannelTransaction.propTypes = {};

export default ChannelTransaction;
